module.exports = __webpack_public_path__ + "img/4064001530.7e99219d.jpg";